<template>
  <v-form class="recovery-form">
    <!--<v-text-field
      v-model="password"
      :error-messages="error['password']"
      label="Password"
      type="text"
      color="teal lighten-2"
      required
      clearable
      outline
      dark
      prepend-inner-icon="fas fa-lock fa-sm"
      class="theme round"
    />-->
    <v-text-field
      v-model="new_password"
      :error-messages="error['repassword']"
      label="Password"
      type="password"
      color="teal lighten-2"
      required
      clearable
      outline
      dark
      prepend-inner-icon="fas fa-lock fa-sm"
      class="theme round"
    />
    {{error['detail']}}
        <div class="new-password-dialog__help">
      <p>Your password must contain at least 8 characters.</p>
    </div>
    <div @click="changePassword">
      <BottomPanel button-text="Reset" />
    </div>
    <v-dialog
      v-model="newPasswordModal"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      class="new-password-dialog"
    >
      <div
        class="new-password-dialog__inner"
      >
        <div>
          <i class="new-password-dialog__icon far fa-check-circle fa-8x"></i>
          <h1 class="new-password-dialog__title">Password has been changed!</h1>
        </div>
      </div>

    </v-dialog>
  </v-form>
</template>

<script>
  import BottomPanel from "./BottomPanel";
  import { mapGetters } from "vuex";
//  import {
  //  RECOVERY_NEW_PASSWORD_REQUEST
  //} from "../store/actions/recovery";

  export default {
    name: "NewPasswordForm",
    components: {
      BottomPanel
    },
    data() {
      return {
        newPasswordModal: false,
        form_title: "",
        uid: this.$route.params.uid,
        token: this.$route.params.token,
        password: "",
        new_password: "",
      };
    },
    computed: {
      ...mapGetters(
        'authentication', ['error'],
        )
    },
    methods: {
      changePassword: function () {
       // const date_record = moment(this.picker).format("YYYY-MM-DD");
        //const activity_id = this.$route.params.id;
        const { uid, token, new_password } = this;

        this.$store
          .dispatch('authentication/userRecoveryConfirm', { uid, token, new_password })
         .then(() => {
           this.newPasswordModal = true;
           setTimeout( () => {
             this.$router.push("/login");
           },3000);
         })
       //   .catch(err => {
        //  });
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.$store.dispatch('authentication/clearErrors');
      })
    }
  };
</script>

<style scoped>
  .new-password-dialog {

  }

  .new-password-dialog__inner {
    height: 100vh;
    background-color: #212121;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }

  .new-password-dialog__icon {
    position: relative;
    padding-bottom: 15px;
    margin-bottom: 15px;
    color: #4DB6AC;
  }

  .new-password-dialog__title {
    font-size: 30px;
    line-height: 35px;
  }
    .new-password-dialog__help p {
    margin-bottom: 2px;
}
</style>
